export default __webpack_public_path__ + "static/Chart1-SM@2x-d3c6d8801d9b72fec5c2db0d2307f3e4.png";